class NostoRecommendations {
  constructor() {
    if (!window.nostojs) {
      throw new Error('Nostro Not initialized')
    }
    this._callback = this._callback.bind(this)
    this._errorCallback = this._errorCallback.bind(this)
    this._makeNostoRequestAndRender()
  }

  loadOnDemand(placementId) {
    return this._makeNostoRequestAndRender([placementId])
  }

  _makeNostoRequestAndRender(placementIDs = []) {
    this._loaded = false
    this._defferedPromise = new Deferred()
    window.nostojs((api) => {
      const request = api.createRecommendationRequest({ includeTagging: true })
      if (Array.isArray(placementIDs) && placementIDs.length > 0) {
        request.setElements(placementIDs)
      }

      request
        .setResponseMode('JSON_ORIGINAL')
        .load()
        .then((res) => {
          const content = {}
          Object.keys(res.recommendations).forEach((divId) => {
            if (res.recommendations[divId].html) {
              content[divId] = res.recommendations[divId].html
            }

            if (res.recommendations[divId].products) {
              const customTitle =
                document.querySelector(`#${divId}`)?.dataset?.title || ''
              const subheading =
                document.querySelector(`#${divId}`)?.dataset?.subheading || ''
              const generatedHTML = this._createSliderForProducts(
                res.recommendations[divId],
                divId,
                customTitle,
                subheading
              )
              // Incase there is a error skip this
              if (generatedHTML) {
                content[divId] = generatedHTML
              }
            }
          })
          api.placements.injectCampaigns(content)
          this._callback(res)
        })
        .catch(this._errorCallback)
    })
  }

  _nostoCarouselTemplate(placementID = '') {
    let tempElem =
      document.getElementById(`nosto-template-${placementID}`) ||
      document.getElementById('nosto-products-carousel-template')
    return tempElem.innerHTML
  }

  _createSliderForProducts(
    recommendation,
    placementID,
    customTitle,
    subheading
  ) {
    try {
      const htmlString = this._nostoCarouselTemplate(placementID)
      const title = customTitle ?? recommendation.title

      return htmlString
        .replaceAll('###divID###', placementID)
        .replaceAll('###title###', title)
        .replaceAll('###subheading###', subheading)
        .replaceAll('###resultID###', recommendation.result_id)
    } catch (error) {
      console.log(error)
      return null
    }
  }

  _callback(response) {
    this._nostoResponse = response
    this._loaded = true
    this._defferedPromise.resolve(this._nostoResponse)
  }

  _errorCallback(error) {
    this._defferedPromise.reject(error)
  }

  getRecommendation() {
    return new Promise(async (resolve, reject) => {
      if (this._loaded) {
        return resolve(this._nostoResponse)
      }
      try {
        await this._defferedPromise.promise
        return resolve(this._nostoResponse)
      } catch (error) {
        reject(error)
      }
    })
  }

  trackAddToCart(productId, resultID) {
    nostojs(function (api) {
      api.recommendedProductAddedToCart(productId, resultID)
    })
  }

  trackProductView(productId, resultID) {
    nostojs(function (api) {
      api
        .createRecommendationRequest()
        .setProducts([{ product_id: productId }], resultID)
        .load()
    })
  }
}

window.__NOSTO_RECOMMENDER__ = new NostoRecommendations()
